import {ExtendedErrorKeys, GSEUploadError, SubjectUploadError} from 'smag-commons/dto/api/massive-upload';
import {I18NService} from '../i18n/i18n.service';

/**
 * SMAG API error codes.
 */
export enum ErrorCode {
    POD_NOT_PART_OF_GIVEN_COMMUNITY = 1034,
    POD_ACTIVE_BEFORE_COMMUNITY = 1036,
    FORBIDDEN_WORDS = 1037,
    PASSWORD_NOT_STRONG = 1038,
    UNKNOWN_POD_FOR_COMMUNITY = 1047,
    INVALID_MEMBER_ID = 1049,
    INVALID_POD = 1050,
    INVALID_MEMBER_JURIDICAL_TYPE = 1057,
    INVALID_POD_UTILITY_TYPE = 1058,
    INVALID_MEMBER_FIRST_NAME = 1060,
    INVALID_MEMBER_LAST_NAME = 1061,
    INVALID_MEMBER_COMPANY_NAME = 1062,
    INVALID_MEMBER_EMAIL = 1063,
    POD_ALREADY_EXISTING = 1067,
    MEMBER_EMAIL_ALREADY_EXISTING = 1068,
    MEMBER_EMAIL_ALREADY_EXISTING_FOR_USER = 1069,
    INVALID_HOLDER_ID = 1075,
    INVALID_OWNER_ID = 1076,
    INVALID_EMAIL = 1082,
    INVALID_MEMBER_MOBILE_NUMBER = 1084,
    INVALID_MOBILE = 1087,
    MEMBER_MOBILE_ALREADY_EXISTING = 1088,
    MEMBER_MOBILE_ALREADY_EXISTING_FOR_USER = 1089,
    UNSUPPORTED_TEMPLATE_TYPE = 1090,
    INVALID_TEMPLATE_TYPE = 1091,
    INVALID_DATE = 1092,
    INVALID_MEASURE = 1093,
    INVALID_TIME_RANGE = 1094,
    DATES_NOT_MATCH_TIME_INTERVAL = 1095,
    UNSUPPORTED_TIME_INTERVAL = 1096,
    INVALID_NEGATIVE_MEASURE = 1097,
    INVALID_FILE_TYPE = 1098,
    POD_RESOURCE_ALREADY_EXISTING = 1099,
    REPRESENTATIVE_EMAIL_ALREADY_EXISTING_FOR_USER = 1110,
    REPRESENTATIVE_MOBILE_ALREADY_EXISTING_FOR_USER = 1111,
    MISSING_REQUIRED_VALUES = 1115,
    INVALID_POD_ACTIVATION_DATE = 1117,
    POD_CONNECTED_TO_NEW_ENTITY_NOT_IN_COMMUNITY = 1123,
    POD_CONNECTED_TO_ENTITY_NOT_IN_COMMUNITY = 1124,
    INVALID_EC_DOCUMENT_ID = 1134,
    MAXIMUM_ROW_NUMBER_EXCEEDED = 1141,
    INVALID_PARTICIPATION_TYPE = 1145,
    INVALID_ACCESS_TYPE = 1146,
    MISSING_REQUIRED_SHEET = 1148,
    INVALID_MEMBER_TAX_ID = 1149,
    INVALID_MEMBER_VAT_ID = 1150,
    INVALID_MEMBER_POSTAL_CODE = 1151,
    INVALID_MEMBER_IBAN = 1152,
    INVALID_MEMBER_ENERGY_PROVIDER = 1153,
    INVALID_NOMINAL_POWER = 1155,
    MISSING_PVS_FOR_PRODUCER = 1156,
    INVALID_CONTRACTUAL_POWER = 1157,
    INVALID_CAPITAL_GRANT_FOR_PV_PLANT = 1158,
    INVALID_POD_TYPE_FOR_THIRD_PARTY_PRODUCER = 1159,
    DUPLICATE_PRODUCTION_POD_VALUES = 1161,
    INVALID_THIRD_PARTY_ACCESS_TYPE = 1162,
    INVALID_SUBJECT_LEGAL_FORM = 1163,
    INVALID_SUBJECT_SUBJECT_TYPE = 1164,
    INVALID_SUBJECT_ENTITY_SUBTYPE = 1165,
    INVALID_POD_UTILITY_TYPE_FOR_SUBJECT = 1166,
    INVALID_PV_PLANT_FOR_POD = 1167,
    INVALID_POD_FOR_SUBJECT = 1168,
    SEU_NOT_ALLOWED = 1169,
    INCONSISTENT_POD_SUBJECT_RELATIONS = 1170,
    MISSING_HOLDER_OWNER = 1172,
    OWNER_SPECIFIED_FOR_THIRD_PARTY_PRODUCER = 1173,
    SEU_MUST_HAVE_HOLDER = 1174,
    SEU_OWNER_NOT_MEMBER = 1175,
    OWNERS_NOT_ALLOWED = 1176,
    INVALID_SIGNATORY_TAX_ID = 1178,
    INVALID_MEMBER_ATECO_CODE = 1177,
    OWNER_SPECIFIED_FOR_POD = 1184,
    HOLDER_SPECIFIED_FOR_PROPERTY_UNIT = 1185,
    MUST_HAVE_HOLDER = 1186,
    MUST_HAVE_OWNER = 1187,
    PROPERTY_UNIT_ALREADY_EXISTING = 1188,
    INVALID_PROPERTY_UNIT_FOR_SUBJECT = 1189,
    INVALID_PROPERTY_UNIT_DATES = 1190,
    INVALID_LAND_REGISTRY_DATA = 1191,
    MEMBER_WITHOUT_POD_OR_PROPERTY_UNIT = 1192,
    INVALID_COMMUNITY_ACTIVATION_DATE = 1193,
    DEVICE_NOT_FOUND = 4013,
    USERNAME_ALREADY_EXIST = 5001,
    EMAIL_ALREADY_EXIST = 5002,
    MOBILE_NUMBER_ALREADY_EXIST = 5003,
    PV_PROFILE_MISCONFIG = 6010,
    CANNOT_CREATE_EC_DOCUMENT = 7019,
    CANNOT_UPDATE_EC_DOCUMENT = 7020,
    CANNOT_DELETE_EC_DOCUMENT = 7021,
    CANNOT_RETRIEVE_EC_DOCUMENT = 7022,
    CANNOT_RETRIEVE_EC_DOCUMENTS = 7023,
    MEMBER_EMAIL_NOT_UNIQUE = 7045,
    MEMBER_MOBILE_NOT_UNIQUE = 7062,

}

/**
 * Authentication Server error codes.
 * These codes *must* match those defined within Authentication Server.
 */
export enum AuthErrorCode {
    WRONG_PASSWORD = 16,
    USED_PASSWORD = 301,
    FORBIDDEN_WORDS = 201,
    PASSWORD_NOT_STRONG = 15
}

/**
 * Economics Server error codes.
 * These codes *must* match those defined within Economics Server.
 */
export enum EconomicsErrorCode {
    INVALID_THOUSANDTHS = 1025,
    INVALID_TOTAL_THOUSANDTHS = 1026,
    INVALID_TOTAL_CAP = 1031,
    INVALID_FIXED_AMOUNT = 1043,
    INVALID_FIXED_PERCENTAGE = 1044,
    INVALID_TOTAL_FIXED_INCENTIVE = 1045,
    INVALID_PERFORMANCE_INCENTIVE = 1046,
    INVALID_THOUSANDTHS_AT_ROW = 1099,
    INVALID_LAND_REGISTRY_DATA_AT_ROW = 1100,
    MULTIPLE_PODS_WITH_SAME_LAND_REGISTRY_DATA = 1101,
    INTRA_YEAR_SUBJECT_CHANGE = 6005
}

export enum GseErrorCode {
    UNKNOWN_POD_FOR_COMMUNITY = 1047,
    BAD_POD_TYPE_FOR_COMMUNITY = 1048,
    MISSING_POD_ABSORPTION_DATA = 1049,
    MISSING_POD_INJECTION_DATA = 1050,
    UNSUPPORTED_EXPORT_FILE = 1051,
    MULTIPLE_ENTRIES_FOR_SAME_POD = 1052,
    INVALID_GSE_FILE = 1053
}

export function mkBaseError(error: SubjectUploadError | GSEUploadError, i18n: I18NService) {
    const {POD, PROPERTY_UNIT, SHEET, SHEET_ROW, SHEET_ROW_COLUMN, PARTICIPATION_TYPE} = ExtendedErrorKeys;
    const messageParts = [POD, PROPERTY_UNIT, SHEET, SHEET_ROW, SHEET_ROW_COLUMN, PARTICIPATION_TYPE]
        .map(key => error.metadata[key] ? i18n.translate(`${key} {0}`, error.metadata[key]) : null)
        .filter(Boolean);
    return messageParts.join(', ');
}
